export default {
    "No message yet": "Aucun message",
    "Loading...": "Chargement...",
    "Add Question": "Ajouter une question",
    "Add question": "Ajouter une question",
    "Tag filter": "Filtre par tag",
    "Asked": "Posées",
    "Published": "Publiées",
    "Deleted": "Supprimées",
    "Edit Question": "Modifier la question",
    "Add tag": "Ajouter un tag",
    "Publish": "Publier",
    "Unpublish": "Dépublier",
    "Delete": "Supprimer",
    "Restore": "Restaurer",
    "Me": "Moi",
    "Waiting for moderation": "En attente de modération",
    "Send": "Envoyer",
    "Please, type a name.": "Veuillez saisir un nom.",
    "The message cannot be empty.": "Le message ne peut pas être vide.",
    "Your question has been sent.": "Votre question a été envoyée.",
    "Name is too long.": "Le nom est trop long.",
    "Name is invalid.": "Le nom est invalide.",
    "Message is invalid.": "Le message est invalide.",
    "The message is too long.": "Le message est trop long.",
    "Please wait before sending another question.": "Veuillez patienter avant d'envoyer une autre question.",
    "Error while sending message": "Erreur lors de l'envoi du message",
    "Error while sending message.": "Erreur lors de l'envoi du message.",
    "Delete Tag": "Supprimer le tag",
    "Are you sure to delete '{0}' tag? This action cannot be undone.": "Êtes-vous sûr de vouloir supprimer le tag '{0}' ? Cette action ne peut pas être annulée.",
    "No": "Non",
    "Yes": "Oui",
    "Add Tag": "Ajouter un tag",
    "Tag": "Tag",
    "Cancel": "Annuler",
    "Save": "Enregistrer",
    "No label" : "Pas de label",
    "This action will delete all 'Asked' and 'Published' questions.": "Cette action va supprimer toutes les questions en état 'Posées' et 'Publiées'.",
    "Delete all questions": "Supprimer toutes les questions",
}